import React from 'react';
import {Alert, Button, Form, Input, Select, Tag, TimePicker} from "antd";
import {PlusCircleOutlined} from "@ant-design/icons";
import './NewTask.less';
import Server from "../../helpers/Server";
import SData from "../../helpers/SData";

export default class NewTask extends React.PureComponent {

    form = React.createRef();

    constructor(props, context) {
        super(props, context);

        this.state = {
            newTaskActivate: 0,
            newTaskName: '',
            newTaskNameError: '',
            newTaskTime: '',
            newTaskTags: [],
            loading: false,
            errorText: '',
        };
    }

    static tagRender(options) {
        return (props) => {
            const {label, value, closable, onClose} = props;
            const onPreventMouseDown = event => {
                event.preventDefault();
                event.stopPropagation();
            };
            return (
                <Tag
                    color={options[value].color}
                    onMouseDown={onPreventMouseDown}
                    closable={closable}
                    onClose={onClose}
                    style={{marginRight: 3}}
                >
                    {label}
                </Tag>
            );
        }
    }

    render() {
        return (<div className={'NewTask activated-' + this.state.newTaskActivate}>
            <Form name="newTask"
                  ref={this.form}
                  className="newTaskForm"
                  initialValues={{remember: true}}
                  onFocus={() => {
                      if (this.state.newTaskActivate === 0) {
                          this.setState({newTaskActivate: 1});
                      }
                  }}
                  onBlur={(data) => {
                      if (this.state.newTaskActivate === 1) {
                          this.setState({newTaskActivate: 0, newTaskTime: null, newTaskTags: []});
                      }
                  }}
                  onFinish={this.onClickAdd}>
                <Form.Item name="name"
                           className='taskName'
                           validateStatus={this.state.newTaskNameError === '' ? null : 'error'}
                           onChange={(v) => {
                               let value = v.target.value;
                               if (this.state.newTaskNameError != '') {
                                   this.setState({
                                       newTaskNameError: ''
                                   });
                               }
                               if (value != null && value.trim().length > 0) {
                                   if (this.state.newTaskActivate < 2) {
                                       this.setState({newTaskActivate: this.state.newTaskTime == null ? 2 : 3});
                                   }
                               } else {
                                   if (this.state.newTaskActivate > 1) {
                                       this.setState({newTaskActivate: 1});
                                   }
                               }
                               this.setState({newTaskName: value, errorText: ''})
                           }}
                           help={this.state.newTaskNameError === '' ? null : this.state.newTaskNameError}>
                    <Input placeholder="Новая задача" autoComplete="off"/>
                </Form.Item>
                <div className='tagsAndTime'>
                    <TimePicker placeholder='Время'
                                className='timePicker'
                                allowClear={false}
                                popupClassName='taskTimePickerPopup'
                                disabledHours={() => [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]}
                                disabledMinutes={(h) => (h === 0 ? [0] : [])}
                                minuteStep={10}
                                format='H:mm'
                                showNow={false}
                                hideDisabledOptions={true}
                                value={this.state.newTaskTime}
                                onSelect={(time) => {
                                    if (time != null && this.state.newTaskActivate < 3) {
                                        this.setState({newTaskActivate: 3});
                                    }
                                    this.setState({newTaskTime: time, errorText: ''});
                                }}
                                onChange={(time, timeString) => this.setState({newTaskTime: time})}/>
                    <Select
                        className='tagsSelect'
                        mode="multiple"
                        tagRender={NewTask.tagRender(this.props.options)}
                        optionFilterProp="label"
                        options={NewTask.tagsToOptions(this.props.options)}
                        value={this.state.newTaskTags}
                        placeholder='Выберите теги'
                        onChange={(value) => this.setState({newTaskTags: value, errorText: ''})}
                        showArrow
                    />
                </div>
                {this.state.errorText == '' ? null : <Alert
                    message={this.state.errorText}
                    className='errorText'
                    type='error'
                    banner
                />}
                <Form.Item style={{marginBottom: 0}}>
                    <Button icon={<PlusCircleOutlined/>} type="default" htmlType="submit" className="addButton"
                            loading={this.state.loading}>
                        Добавить задачу
                    </Button>
                </Form.Item>
            </Form>
        </div>);
    }

    onClickAdd = (formData) => {
        if (this.state.loading){
            return;
        }
        let name = this.state.newTaskName;
        let timeObj = this.state.newTaskTime;
        let tags = this.state.newTaskTags;
        let time = timeObj.hours() * 60 + timeObj.minutes();
        if (time == null || time < 1){
            this.setState({errorText: "Вы не указали время выполнения задачи!"});
            return;
        }
        this.setState({loading: true});
        Server.query(Server.QUERY_TASKS, {a: 'add', name, time, tags}, (response) => {
            let r = response.data;
            if (r.status) {
                SData.setFromServerBase(r.base);
                SData.setFromServerTasks(r.tasks);
                this.setState({
                    newTaskName: '',
                    newTaskTime: null,
                    newTaskTags: [],
                    newTaskActivate: 0,
                    loading: false,
                    errorText: '',
                });
                this.form.current.setFieldsValue({
                    name: '',
                });
            } else {
                this.setState({loading: false, errorText: r.error});
            }
        }, () => {
            this.setState({loading: false, errorText: Server.ERROR_TEXT_CONNECTION});
        });
    }

    static tagsToOptions(tags) {
        let arr = [];
        for (const tagsKey in tags) {
            arr.push({label: tags[tagsKey].label, value: tagsKey});
        }
        return arr;
    }
}